var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * CZNA-1106 — import a MARCXML file from the Authorities screen, in two steps.
 *
 * 1. The cataloguer picks a file. It is uploaded and dry-run: the backend works
 *    out what the import would do and writes nothing (`POST /import/preview`).
 * 2. The summary is shown. Only "Import" starts the real import, with the same
 *    strategy the summary assumed; "Cancel" (or closing the dialog) deletes the
 *    uploaded file and nothing is written.
 *
 * The strategy is fixed to REPLACE. The point of importing an edited export back
 * is that the file's content wins; SKIP would report every existing record as
 * skipped and change nothing. There is no MERGE: an import never merges records
 * and the backend rejects MERGE with 400 (CZNA-1622).
 *
 * The NK download on the Importy screen is a different path (`start-from-nkp`)
 * and is not touched by this dialog.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useOkapiKy } from '@folio/stripes/core';
import { Button, Loading, MessageBanner, Modal, ModalFooter, } from '@folio/stripes/components';
import { deleteImportFile, previewImport, startImportFromFile, uploadImportFile, } from '../../api/importService';
import { isTimeoutError } from '../../utils/errorKind';
import { AuthorityTypeLabel } from '../AuthorityTypeCard';
import { isAcceptedImportFile, prepareImportFile, UPLOAD_LIMIT_BYTES, } from '../../utils/prepareImportFile';
var STRATEGY = 'REPLACE';
/** How many field tags the per-field breakdown lists before it stops. */
var FIELD_ROWS_SHOWN = 15;
var TABLE_STYLE = {
    borderCollapse: 'collapse',
    width: '100%',
    marginBottom: '1rem',
};
var CELL_STYLE = {
    borderBottom: '1px solid #e0e0e0',
    padding: '0.25rem 0.5rem',
    textAlign: 'left',
    verticalAlign: 'top',
};
var NUM_STYLE = __assign(__assign({}, CELL_STYLE), { textAlign: 'right' });
var HEADLINE_STYLE = { margin: '1rem 0 0.5rem', fontSize: '1rem' };
/**
 * Reads the backend's `{ error }` body off a failed ky request. Returns null when
 * there is none — the caller then falls back to a message of its own.
 */
var readServerError = function (e) { return __awaiter(void 0, void 0, void 0, function () {
    var response, body, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                response = e === null || e === void 0 ? void 0 : e.response;
                if (!(response === null || response === void 0 ? void 0 : response.json))
                    return [2 /*return*/, null];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, response.json()];
            case 2:
                body = _b.sent();
                return [2 /*return*/, typeof (body === null || body === void 0 ? void 0 : body.error) === 'string' ? body.error : null];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var statusOf = function (e) { var _a; return (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status; };
var SummaryRow = function (_a) {
    var id = _a.id, value = _a.value;
    return (React.createElement("tr", null,
        React.createElement("th", { scope: "row", style: CELL_STYLE },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.summary.".concat(id) })),
        React.createElement("td", { style: NUM_STYLE, "data-testid": "import-file-summary-".concat(id) }, value)));
};
var ImportFileModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onImported = _a.onImported;
    var intl = useIntl();
    var ky = useOkapiKy();
    var fileInputRef = useRef(null);
    var _b = useState('select'), step = _b[0], setStep = _b[1];
    var _c = useState(null), file = _c[0], setFile = _c[1];
    var _d = useState(null), preview = _d[0], setPreview = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    /** CZNA-1625 — the start got no answer in time, so the import may be running already. */
    var _f = useState(false), startTimedOut = _f[0], setStartTimedOut = _f[1];
    /**
     * The name the file was stored under on the server, while it is still there.
     * A ref, not state: the close handler must see the value the upload just set
     * even when it runs in the same tick, and it is never rendered.
     */
    var uploadedNameRef = useRef(null);
    /** Bumped on every close, so a dry run that returns after the dialog closed is ignored. */
    var generationRef = useRef(0);
    // A controlled Modal keeps its state across close/reopen — start clean each time.
    useEffect(function () {
        if (open) {
            setStep('select');
            setFile(null);
            setPreview(null);
            setError(null);
            setStartTimedOut(false);
            uploadedNameRef.current = null;
        }
    }, [open]);
    var discardUpload = useCallback(function () {
        var name = uploadedNameRef.current;
        uploadedNameRef.current = null;
        if (name) {
            // Best effort: a file left behind costs disk in the module's temp dir, not
            // data, and the user has already decided not to import it.
            deleteImportFile(ky, name).catch(function () { return undefined; });
        }
    }, [ky]);
    /** Reject: the summary was seen and declined, or the dialog closed before the import. */
    var handleCancel = useCallback(function () {
        // Once "Import" is pressed the file belongs to the import being started; deleting it
        // now could pull it out from under the batch. The dialog closes when the start answers.
        if (step === 'starting')
            return;
        generationRef.current += 1;
        discardUpload();
        onClose();
    }, [discardUpload, onClose, step]);
    var handlePreview = function () { return __awaiter(void 0, void 0, void 0, function () {
        var generation, prepared, result, e_1, status_1, serverMessage, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file)
                        return [2 /*return*/];
                    generation = generationRef.current;
                    setError(null);
                    setStep('working');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 7]);
                    return [4 /*yield*/, prepareImportFile(file)];
                case 2:
                    prepared = _a.sent();
                    if (prepared.body.size > UPLOAD_LIMIT_BYTES) {
                        setError(intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.tooLarge' }, { limit: Math.round(UPLOAD_LIMIT_BYTES / (1024 * 1024)) }));
                        setStep('select');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, uploadImportFile(ky, prepared.body, prepared.name)];
                case 3:
                    _a.sent();
                    uploadedNameRef.current = prepared.name;
                    if (generation !== generationRef.current) {
                        discardUpload();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, previewImport(ky, prepared.name, STRATEGY)];
                case 4:
                    result = _a.sent();
                    if (generation !== generationRef.current)
                        return [2 /*return*/];
                    setPreview(result);
                    setStep('preview');
                    return [3 /*break*/, 7];
                case 5:
                    e_1 = _a.sent();
                    if (generation !== generationRef.current)
                        return [2 /*return*/];
                    // A dry run that failed leaves nothing to confirm, so the file goes too.
                    discardUpload();
                    status_1 = statusOf(e_1);
                    return [4 /*yield*/, readServerError(e_1)];
                case 6:
                    serverMessage = _a.sent();
                    message = void 0;
                    if (status_1 === 413) {
                        message = intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.tooLarge' }, { limit: Math.round(UPLOAD_LIMIT_BYTES / (1024 * 1024)) });
                    }
                    else if (serverMessage) {
                        message = intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.previewWithReason' }, { reason: serverMessage });
                    }
                    else {
                        message = intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.preview' });
                    }
                    setError(message);
                    setStep('select');
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var name, batchId, e_2, serverMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = uploadedNameRef.current;
                    if (!name || !preview)
                        return [2 /*return*/];
                    setError(null);
                    setStep('starting');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, startImportFromFile(ky, name, STRATEGY)];
                case 2:
                    batchId = (_a.sent()).batchId;
                    // The import owns the file now and deletes it when the batch ends.
                    uploadedNameRef.current = null;
                    onImported(batchId, preview);
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    // CZNA-1625 — no answer in time: the import may have started and own the file. Keep the
                    // file on cancel and offer no second start; the user checks the batch list instead.
                    if (isTimeoutError(e_2)) {
                        uploadedNameRef.current = null;
                        setStartTimedOut(true);
                        setError(intl.formatMessage({ id: 'ui-czna-authorities.error.timeout' }));
                        setStep('preview');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, readServerError(e_2)];
                case 4:
                    serverMessage = _a.sent();
                    setError(serverMessage
                        ? intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.startWithReason' }, { reason: serverMessage })
                        : intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.start' }));
                    setStep('preview');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var nothingToImport = !!preview && preview.newCount + preview.updatedCount === 0;
    var footer = (React.createElement(ModalFooter, null,
        step === 'preview' || step === 'starting' ? (React.createElement(Button, { buttonStyle: "primary", onClick: handleConfirm, disabled: step === 'starting' || nothingToImport || startTimedOut, "data-testid": "import-file-confirm" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.confirm" }))) : (React.createElement(Button, { buttonStyle: "primary", onClick: handlePreview, disabled: !file || step === 'working', "data-testid": "import-file-preview" },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.preview" }))),
        React.createElement(Button, { onClick: handleCancel, disabled: step === 'starting', "data-testid": "import-file-cancel" },
            React.createElement(FormattedMessage, { id: step === 'preview'
                    ? 'ui-czna-authorities.importFile.reject'
                    : 'ui-czna-authorities.importFile.cancel' }))));
    var renderSelect = function () { return (React.createElement(React.Fragment, null,
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.intro" })),
        React.createElement("input", { ref: fileInputRef, type: "file", accept: ".xml,.gz,application/xml,text/xml,application/gzip", "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.importFile.fileLabel' }), "data-testid": "import-file-input", disabled: step === 'working', onChange: function (e) {
                var _a, _b;
                var picked = (_b = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
                setError(null);
                if (picked && !isAcceptedImportFile(picked.name)) {
                    setFile(null);
                    setError(intl.formatMessage({ id: 'ui-czna-authorities.importFile.error.extension' }));
                    return;
                }
                setFile(picked);
            } }),
        step === 'working' && (React.createElement("div", { style: { marginTop: '1rem' }, "data-testid": "import-file-working" },
            React.createElement(Loading, null),
            ' ',
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.working" }))))); };
    var renderPreview = function (p) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var fields = ((_a = p.byField) !== null && _a !== void 0 ? _a : []).slice(0, FIELD_ROWS_SHOWN);
        return (React.createElement("div", { "data-testid": "import-file-summary" },
            React.createElement("table", { style: TABLE_STYLE },
                React.createElement("tbody", null,
                    React.createElement(SummaryRow, { id: "updated", value: p.updatedCount }),
                    React.createElement(SummaryRow, { id: "new", value: p.newCount }),
                    React.createElement(SummaryRow, { id: "changedFields", value: p.changedFieldCount }),
                    React.createElement("tr", null,
                        React.createElement("th", { scope: "row", style: CELL_STYLE },
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.summary.averageChangedFields" })),
                        React.createElement("td", { style: NUM_STYLE, "data-testid": "import-file-summary-averageChangedFields" }, intl.formatNumber(p.averageChangedFieldsPerRecord, { maximumFractionDigits: 1 }))),
                    React.createElement(SummaryRow, { id: "unchanged", value: p.unchangedCount }),
                    p.skippedCount > 0 && React.createElement(SummaryRow, { id: "skipped", value: p.skippedCount }),
                    p.retypedCount > 0 && React.createElement(SummaryRow, { id: "retyped", value: p.retypedCount }),
                    p.deletedCount > 0 && React.createElement(SummaryRow, { id: "deleted", value: p.deletedCount }),
                    React.createElement(SummaryRow, { id: "failed", value: p.failedCount }),
                    React.createElement(SummaryRow, { id: "total", value: p.totalCount }))),
            nothingToImport && (React.createElement(MessageBanner, { type: "warning" },
                React.createElement("span", { "data-testid": "import-file-nothing" },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.nothingToImport" })))),
            ((_b = p.byType) !== null && _b !== void 0 ? _b : []).length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("h3", { style: HEADLINE_STYLE },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.byType" })),
                React.createElement("table", { style: TABLE_STYLE },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { style: CELL_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.type' })),
                            React.createElement("th", { style: NUM_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.new' })),
                            React.createElement("th", { style: NUM_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.updated' })))),
                    React.createElement("tbody", null, ((_c = p.byType) !== null && _c !== void 0 ? _c : []).map(function (t) { return (React.createElement("tr", { key: t.type },
                        React.createElement("td", { style: CELL_STYLE },
                            React.createElement(AuthorityTypeLabel, { type: t.type })),
                        React.createElement("td", { style: NUM_STYLE }, t.newCount),
                        React.createElement("td", { style: NUM_STYLE }, t.updatedCount))); }))))),
            fields.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("h3", { style: HEADLINE_STYLE },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.byField" })),
                React.createElement("table", { style: TABLE_STYLE, "data-testid": "import-file-by-field" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { style: CELL_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.field' })),
                            React.createElement("th", { style: NUM_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.inserted' })),
                            React.createElement("th", { style: NUM_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.changed' })),
                            React.createElement("th", { style: NUM_STYLE }, intl.formatMessage({ id: 'ui-czna-authorities.importFile.col.removed' })))),
                    React.createElement("tbody", null, fields.map(function (f) { return (React.createElement("tr", { key: f.fieldTag },
                        React.createElement("td", { style: CELL_STYLE }, f.fieldTag),
                        React.createElement("td", { style: NUM_STYLE }, f.insertedCount),
                        React.createElement("td", { style: NUM_STYLE }, f.updatedCount),
                        React.createElement("td", { style: NUM_STYLE }, f.deletedCount))); }))),
                ((_d = p.byField) !== null && _d !== void 0 ? _d : []).length > FIELD_ROWS_SHOWN && (React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.moreFields", values: { count: ((_e = p.byField) !== null && _e !== void 0 ? _e : []).length - FIELD_ROWS_SHOWN } }))))),
            ((_f = p.samples) !== null && _f !== void 0 ? _f : []).length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("h3", { style: HEADLINE_STYLE },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.samples", values: { count: ((_g = p.samples) !== null && _g !== void 0 ? _g : []).length } })),
                ((_h = p.samples) !== null && _h !== void 0 ? _h : []).map(function (s) {
                    var _a, _b, _c;
                    return (React.createElement("details", { key: "".concat(s.action, "-").concat(s.controlNumber), "data-testid": "import-file-sample" },
                        React.createElement("summary", null,
                            React.createElement("strong", null, s.controlNumber),
                            ' — ', (_a = s.heading) !== null && _a !== void 0 ? _a : '',
                            ' (',
                            React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.action.".concat(s.action) }),
                            s.action === 'UPDATED' && (React.createElement(React.Fragment, null,
                                ', ',
                                React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.changeCount", values: { count: s.changeCount } }))),
                            ")"),
                        ((_b = s.changes) !== null && _b !== void 0 ? _b : []).length > 0 && (React.createElement("table", { style: TABLE_STYLE },
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", { scope: "col", style: CELL_STYLE },
                                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.changes.field" })),
                                    React.createElement("th", { scope: "col", style: CELL_STYLE },
                                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.changes.operation" })),
                                    React.createElement("th", { scope: "col", style: CELL_STYLE },
                                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.changes.oldValue" })),
                                    React.createElement("th", { scope: "col", style: CELL_STYLE },
                                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.changes.newValue" })))),
                            React.createElement("tbody", null, ((_c = s.changes) !== null && _c !== void 0 ? _c : []).map(function (c) {
                                var _a, _b, _c, _d, _e;
                                return (React.createElement("tr", { key: "".concat(c.fieldTag, "-").concat(c.fieldIndex, "-").concat((_a = c.subfieldCode) !== null && _a !== void 0 ? _a : '', "-").concat(c.operation, "-").concat((_b = c.oldValue) !== null && _b !== void 0 ? _b : '', "-").concat((_c = c.newValue) !== null && _c !== void 0 ? _c : '') },
                                    React.createElement("td", { style: CELL_STYLE },
                                        c.fieldTag,
                                        c.subfieldCode ? " $".concat(c.subfieldCode) : ''),
                                    React.createElement("td", { style: CELL_STYLE },
                                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.op.".concat(c.operation) })),
                                    React.createElement("td", { style: CELL_STYLE }, (_d = c.oldValue) !== null && _d !== void 0 ? _d : ''),
                                    React.createElement("td", { style: CELL_STYLE }, (_e = c.newValue) !== null && _e !== void 0 ? _e : '')));
                            }))))));
                }))),
            ((_j = p.failures) !== null && _j !== void 0 ? _j : []).length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("h3", { style: HEADLINE_STYLE },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.failures" })),
                React.createElement("ul", { "data-testid": "import-file-failures" }, ((_k = p.failures) !== null && _k !== void 0 ? _k : []).map(function (f) {
                    var _a;
                    return (React.createElement("li", { key: f.recordNumber },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.importFile.failure", values: { number: f.recordNumber, controlNumber: (_a = f.controlNumber) !== null && _a !== void 0 ? _a : '—', message: f.message } })));
                }))))));
    };
    return (React.createElement(Modal, { open: open, label: intl.formatMessage({ id: 'ui-czna-authorities.importFile.title' }), onClose: handleCancel, footer: footer, size: "large", dismissible: true, id: "import-file-modal" },
        error && (React.createElement(MessageBanner, { type: "error" },
            React.createElement("span", { "data-testid": "import-file-error" }, error))),
        (step === 'preview' || step === 'starting') && preview
            ? renderPreview(preview)
            : renderSelect()));
};
export default ImportFileModal;
